<template>
    <div class="nomocracy">
        <div class="nomocracy__description">
            <div class="nomocracy__text-content">
                <div class="text-block -trAnim-1">
                    <h4>Distribute by<br>usage statistics</h4>
                    <ul>
                        <li>Population Policy</li>
                        <li>Proof of Play</li>
                    </ul>
                    <div class="arrow -trAnim-2">
                        <svg width="130" height="116" viewBox="0 0 130 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_260_385)">
                                <path d="M84.9744 53.67L78.6422 58.4L59.9939 44.46L41.3321 58.4L35 53.67L59.9939 35L84.9744 53.67Z" fill="var(--color-path-1)"/>
                                <path d="M76.1251 65.3095L69.793 70.0394L59.9936 62.7094L50.1808 70.0394L43.8486 65.3095L59.9936 53.2495L76.1251 65.3095Z" fill="var(--color-path-2)"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_260_385" x="0" y="0" width="129.975" height="115.039" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dx="5" dy="5"/>
                                    <feGaussianBlur stdDeviation="20"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_260_385"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_260_385" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="text-block -trAnim-2">
                    <h4>Distribute by<br>economic activities</h4>
                    <ul>
                        <li>Turnover Tax</li>
                        <li>GDP</li>
                    </ul>
                    <div class="arrow -trAnim-3">
                        <svg width="130" height="116" viewBox="0 0 130 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_260_385)">
                                <path d="M84.9744 53.67L78.6422 58.4L59.9939 44.46L41.3321 58.4L35 53.67L59.9939 35L84.9744 53.67Z" fill="var(--color-path-1)"/>
                                <path d="M76.1251 65.3095L69.793 70.0394L59.9936 62.7094L50.1808 70.0394L43.8486 65.3095L59.9936 53.2495L76.1251 65.3095Z" fill="var(--color-path-2)"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_260_385" x="0" y="0" width="129.975" height="115.039" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dx="5" dy="5"/>
                                    <feGaussianBlur stdDeviation="20"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_260_385"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_260_385" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="text-block -trAnim-3">
                    <h4>Distribute by<br>Keynesian controls</h4>
                    <ul>
                        <li>Cold Start Impressions</li>
                        <li>Non-profit Content</li>
                        <li>Ad Unit</li>
                    </ul>
                    <div class="arrow -trAnim-4">
                        <svg width="130" height="116" viewBox="0 0 130 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_260_385)">
                                <path d="M84.9744 53.67L78.6422 58.4L59.9939 44.46L41.3321 58.4L35 53.67L59.9939 35L84.9744 53.67Z" fill="var(--color-path-1)"/>
                                <path d="M76.1251 65.3095L69.793 70.0394L59.9936 62.7094L50.1808 70.0394L43.8486 65.3095L59.9936 53.2495L76.1251 65.3095Z" fill="var(--color-path-2)"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_260_385" x="0" y="0" width="129.975" height="115.039" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dx="5" dy="5"/>
                                    <feGaussianBlur stdDeviation="20"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_260_385"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_260_385" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="subtitle -trAnim-4">
                <p>Monetary Policy</p>
                <div class="divider"></div>
                <p>Fiscal Policy</p>
            </div>
            <h2 class="screen-title -trAnim-5">nomocracy</h2>
        </div>
    </div>
</template>

<script>
export default {
    name: 'nomocracyScreen',
    data() {
        return {

        }
    }
}
</script>

<style lang='scss'>
    .nomocracy {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width: point(sm)) {
            flex-direction: column;
            justify-content: center;
        }
        &:after {
            content: '';
            display: block;
            position: absolute;
            background: url(../assets/images/blur-11.png) no-repeat;
            background-size: contain;
            background-position: center;
            width: 100vw;
            height: 100vw;
            left: 50%; top: 50%;
            transform: translate(-50%, -50%);
            opacity: .7;
            z-index: 1;
            @media screen and (max-width: point(sm)) {
                width: 100vh;
                height: 100vh;
            }
        }
    }
    .nomocracy__description {
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 3;

        @media screen and (max-width: point(sm)) {
            align-items: center;
            width: 100%;
        }

        .screen-title {
            margin-top: 3.375rem;

            @media screen and (max-width: point(sm)) {
                margin-top: 2rem;

                @media screen and (min-aspect-ratio: 375 / 615) {
                    margin-top: -.5rem;
                }
            }
        }

        .subtitle {
            display: flex;
            justify-content: center;
            align-items: center;
            @include font-azonix;
            font-size: font(22);
            margin-top: 4rem;

            @media screen and (max-width: point(sm)) {
                width: 100%;
                margin-top: 1rem;

                @media screen and (min-aspect-ratio: 375 / 650) {
                    display: none;
                }
            }
        }

        .divider {
            height: 1.5rem;
            width: 1px;
            background: color('white');
            margin: 0 3rem;
        }

        p {
            width: 14.3125rem;
        }
    }
    .nomocracy__text-content {
        display: flex;
        justify-content: center;
        align-items: flex-start;

        @media screen and (max-width: point(sm)) {
            flex-direction: column;
        }

        .text-block {
            --text-block-height: 6.25rem;
            position: relative;
            margin-bottom: var(--text-block-height);
            height: 6.125rem;
            @media screen and (max-width: point(sm)) {
                margin-bottom: 2rem;
                margin-left: 5rem !important;
                height: auto;
            }
            
            h4 {
                @include font-medium;
                font-size: font(18);
            }

            ul {
                margin-top: 0.625rem;

                li:not(:first-child) {
                    @include font-light;
                    font-size: font(16);
                    margin-top: .5rem;
                }
                li {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                
                    &:before {
                        content: '';
                        display: block;
                        width: 3px;
                        height: 3px;
                        min-width: 3px;
                        min-height: 3px;
                        background: color('white');
                        border-radius: 50%;
                        margin-right: 1rem;
                    }
                }
            }
            .arrow {
                position: absolute;
                display: block;
                width: 7.125rem;
                height: 7.1875rem;
                top: calc(100% + var(--text-block-height) / 3); left: 50%;
                transform: translate(-50%);

                @media screen and (max-width: point(sm)) {
                    left: auto;
                    top: 50%;
                    right: 100%;
                    transform: translate(0, -50%);
                }

                svg {
                    width: 100%;
                    height: 100%;
                    min-width: 100%;
                    min-height: 100%;
                }
            }
        }

        .text-block:nth-child(2) {margin-left: 8.4375rem; margin-right: 7.4375rem;}
        @media screen and (max-width: point(sm)) {
        .text-block:nth-child(2) {margin-left: 0; margin-right: 0;}
        }
    }
    // arrow animation
    .nomocracy__text-content .arrow {
        --color-path-1: rgba(255, 255, 255, .3);
        --color-path-2: white;
        animation: 1.5s lighten infinite;

        svg path {
            transition: fill .5s ease;
        }
    }
    // animation styles before
    .nomocracy {
        &:before, &:after {
            opacity: 0;
            transition: calc(var(--content-appear-time) + .5s) opacity;
        }
    }
    // animation styles after
    .nomocracy.active {
        &:before, &:after {
            opacity: 1;
        }
    }
</style>
